import { defineComponent as _defineComponent } from 'vue'
import { computed, type ComputedRef } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useUserStore } from "@/store/user";
import routesName from "@/utils/constants/routesName";
import routesMetaTypes from "@/utils/constants/routesMetaTypes";
import { useVideographerStore } from "@/store/videographer";
import type { IVideographer } from "@/types/entities/IVideographer";
import VideographersMenuButton from "@/components/VideographersMenuButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();
const isGameOrderPage: ComputedRef<boolean> = computed(
  () => route.matched[0]?.name === routesName.orders
);
const isDistributionPage: ComputedRef<boolean> = computed(
  () => route.matched[0]?.name === routesName.distributions
);

const routeMetaTypeIndex: ComputedRef<number> = computed(() => {
  if (isGameOrderPage.value) {
    return 0;
  }
  switch (route.meta.type) {
    case routesMetaTypes.orders:
      return 0;
    case routesMetaTypes.videographers:
      return 1;
    case routesMetaTypes.corporateClients:
      return 2;
    case routesMetaTypes.users:
      return 3;
    case routesMetaTypes.coupons:
      return 4;
    case routesMetaTypes.statistics:
      return 5;
    case routesMetaTypes.distributions:
      return 6;
    default:
      return -1;
  }
});
const pageTitleNames = [
  "Games",
  "Videographers",
  "Corporate Clients",
  "Users",
  "Coupons",
  "Statistics",
  "Distributions",
];
const pageTitle = computed(() => pageTitleNames[routeMetaTypeIndex.value]);
const pageIconNames = [
  "icon_rugby",
  "icon_camera",
  "icon_smile",
  "icon_people",
  "icon_smile",
  "icon_statistics",
  "icon_distribution",
];
const pageIcon = computed(() => pageIconNames[routeMetaTypeIndex.value]);

const videographerStore = useVideographerStore();
const croppedVideographers: ComputedRef<IVideographer[]> = computed(
  () => videographerStore.croppedVideographers
);
const hiddenVideographers: ComputedRef<IVideographer[]> = computed(
  () => videographerStore.hiddenVideographers
);
const croppedVideographersByDay: ComputedRef<IVideographer[]> = computed(
  () => videographerStore.croppedVideographersByDay
);
const hiddenVideographersByDay: ComputedRef<IVideographer[]> = computed(
  () => videographerStore.hiddenVideographersByDay
);

const userStore = useUserStore();
const logout = () => {
  userStore.clear();
};

const __returned__ = { route, router, isGameOrderPage, isDistributionPage, routeMetaTypeIndex, pageTitleNames, pageTitle, pageIconNames, pageIcon, videographerStore, croppedVideographers, hiddenVideographers, croppedVideographersByDay, hiddenVideographersByDay, userStore, logout, computed, useRoute, useRouter, useUserStore, routesName, routesMetaTypes, useVideographerStore, VideographersMenuButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})